@if (deviceService.isMobile && userService.isAuthenticated) {
    @if (!isDataLoaded) {
        <div class="user-banner-loader">
            <div class="details">
                <div class="background-color label"></div>
                <div class="background-color id"></div>
            </div>
            <div class="background-color button"></div>
        </div>
    } @else {
        <div class="user-banner" data-testid="userBanner">
            <div class="banner-content" data-testid="bannerContent">
                <div>
                    <div class="user-name" data-testid="userName">{{ userName | titlecase }}</div>
                    @if (content?.MGMRewardsId) {
                        <div class="rewards-details" data-testid="rewardsDetails">
                            <span data-testid="rewardsLabel">{{ content?.MGMRewardstext }}</span>
                            <span data-testid="rewardsId">{{ content?.MGMRewardsId }}</span>
                        </div>
                    }
                </div>
                @if (content?.ViewCardButton) {
                    <button ds-button variant="outline" kind="secondary" size="small" data-testid="viewCardButton" (click)="viewCardClick()">
                        {{ content?.ViewCardButton }}
                    </button>
                }
            </div>
        </div>
    }
}
